import { useQuery } from '@tanstack/react-query';

import { individualConfigurationsService } from '@aslanpay/portal-common-lib';

export const fetchIndividualConfigurationQuery = (id?: string, enabled = true) => ({
  queryKey: ['fetchIndividualConfiguration', id],
  queryFn: async () => {
    return individualConfigurationsService.fetchIndividualConfiguration(id || '');
  },
  enabled: !!id && enabled,
});

const useFetchIndividualConfiguration = (id?: string, enabled = true) => {
  return useQuery(fetchIndividualConfigurationQuery(id, enabled));
};

export default useFetchIndividualConfiguration;
